<template>
    <button
        @click="closeModal"
        class="close modal-close"
        :class="{ disabled: disabled }"
    >
        <span>×</span>
    </button>
</template>

<script>
export default {
    props: {
        confirmation: {
            type: Object,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        onClose: {
            type: Function,
            required: false
        }
    },
    methods: {
        closeModal() {
            if (this.onClose) {
                this.onClose()
            } else {
                if (this.confirmation) {
                    this.$store.dispatch(
                        'openConfirmationWindow',
                        this.confirmation
                    )
                } else {
                    this.$store.dispatch('toggleModal', false)
                }
            }
        }
    }
}
</script>
